<template>
  <section class="about-us-section">
    <div class="container">
      <!-- Section Header -->

      <!-- CEO Section -->

      <div class="leader-profile founder-row">
        <div class="profile-visual animate-up delay-1">
          <div class="image-wrapper">
            <img
              src="@/assets/images/VipandeepSingh.jpg"
              alt="Vipandeep Singh"
              class="profile-img"
            />
            <div class="floating-badge">
              <span class="years">VIPANDEEP SINGH</span>
              <span class="focus">Founder, Client's Preferred</span>
            </div>
          </div>
        </div>

        <div class="profile-info animate-up delay-2">
          <div class="info-header">
            <span class="role-tag">Excellence & Integrity</span>
            <h2 class="name">Vipandeep Singh</h2>
            <p class="title">Founder, Clients Preferred Property Hub</p>
          </div>

          <div class="bio-text">
            <p>
              Vipandeep Singh is a visionary entrepreneur, real estate advisor,
              and venture builder with a growing portfolio of businesses across
              multiple sectors. He is the founder of Clients Preferred Property
              Hub, a trust-driven real estate consultancy focused on verified,
              GMADA & RERA-approved projects across Tricity.
            </p>
            <p>
              With deep local market knowledge and a hands-on leadership
              approach, he helps homebuyers and investors make informed,
              future-ready decisions while simultaneously expanding ventures
              that align with transparency, quality, and credibility.
            </p>
            <p>
              Beyond real estate advisory, Vipandeep is actively building and
              scaling multiple ventures. For him, business is not just about
              growth — it’s about building trusted brands and lasting impact.
            </p>
          </div>
        </div>
      </div>

      <div class="profile-divider"></div>

      <!--CMO-->

      <div class="leader-profile founder-row">
        <div class="profile-visual animate-up delay-1">
          <div class="image-wrapper">
            <img
              src="@/assets/images/AnkitSuryavanshi.jpg"
              alt="Vipandeep Singh"
              class="profile-img"
            />
            <div class="floating-badge">
              <span class="years">ANKIT SURYAVANSHI</span>
              <span class="focus">Chief Operating Officer</span>
            </div>
          </div>
        </div>

        <div class="profile-info animate-up delay-2">
          <div class="info-header">
            <span class="role-tag">Growth & Governance</span>
            <h2 class="name">Ankit Suryavanshi</h2>
            <p class="title">Chief Operating Officer</p>
            <div
              class="experience-badge"
              style="
                display: inline-flex;
                align-items: center;
                gap: 6px;
                font-size: 13px;
                font-weight: 600;
                color: #1a1a1a;
                background-color: #ebebeb;
                padding: 6px 12px;
                border-radius: 20px;
                margin-top: 3px;
              "
            >
              <span>⏱</span>
              <span>{{ cooExperience }}+ Years of Industry Expertise</span>
            </div>
          </div>

          <div class="bio-text">
            <p>
              Ankit Suryavanshi specializes in helping clients seamlessly bridge
              the gap between discovering the right property and securing the
              most suitable financing solutions. With over {{ cooExperience }}
              years of experience in residential real estate, he brings a
              unique, data-driven perspective to the Tricity.
            </p>
            <p>
              His expertise lies in simplifying complex real estate deals by
              offering clear insights, strategic planning, and end-to-end
              support. Ankit is committed to ensuring that every investment
              decision is not only smooth but also aligned with long-term
              profitability.
            </p>
            <p>
              Whether you are a first-time homebuyer or a seasoned investor,
              Ankit provides proactive guidance backed by market analysis,
              helping you make confident, well-informed decisions that optimize
              your ROI.
            </p>
          </div>
        </div>
      </div>

      <div class="stat-and-contact">
        <div class="stats-row">
          <div class="stat-box">
            <span class="stat-num">100%</span>
            <span class="stat-desc">Client Focused</span>
          </div>
          <div class="stat-box">
            <span class="stat-num">GTA</span>
            <span class="stat-desc">Expertise</span>
          </div>
        </div>

        <div class="contact-card-rows">
          <div class="location-header">
            <a
              href="https://www.google.com/maps/search/?api=1&query=Gillco+Valley+Sector-127+Kharar+Mohali"
              target="_blank"
              class="location-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>Gillco Valley Sector-127, Mohali</span>
            </a>
          </div>

          <div class="executive-rows">
            <div class="exec-row-item">
              <div class="exec-meta">
                <span class="exec-badge">CEO</span>
                <span class="exec-name">Vipandeep Singh</span>
                <span class="exec-role-desktop">Chief Executive Officer</span>
              </div>
              <a href="tel:+917087931778" class="phone-action-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  ></path>
                </svg>
                <span>+91 70879 31778</span>
              </a>
            </div>

            <div class="exec-row-item">
              <div class="exec-meta">
                <span class="exec-badge">COO</span>
                <span class="exec-name">Ankit Suryavanshi</span>
                <span class="exec-role-desktop">Chief Operating Officer</span>
              </div>
              <a href="tel:+917696707433" class="phone-action-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  ></path>
                </svg>
                <span>+91 76967 07433</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const COO_START_YEAR = 2021;

const cooExperience = computed(() => {
  const currentYear = new Date().getFullYear();
  return currentYear - COO_START_YEAR;
});
</script>

<style scoped>
.contact-card-rows {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  max-width: 750px;
  font-family: system-ui, -apple-system, sans-serif;
  box-sizing: border-box; /* Prevents container sizing blowout */
}

.location-header {
  margin-bottom: 20px;
}

.location-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #1e293b;
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
}

.location-link svg {
  color: #b91c1c;
  flex-shrink: 0;
}

.executive-rows {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.exec-row-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
  gap: 16px; /* Increased gap for a cleaner breakpoint transition */
  box-sizing: border-box;
}

.exec-row-item:hover {
  background: #f1f5f9;
  border-color: #ecb9b9;
}

.exec-meta {
  display: flex;
  align-items: center;
  gap: 12px;
}

.exec-badge {
  background: #f4d6d6;
  color: #b91c1c;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  min-width: 38px;
  text-align: center;
  flex-shrink: 0;
}

.exec-name {
  font-weight: 600;
  color: #0f172a;
  font-size: 15px;
}

.exec-role-desktop {
  font-size: 13px;
  color: #64748b;
}

.phone-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  padding: 8px 14px;
  border-radius: 6px;
  color: #b91c1c;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  box-sizing: border-box;
  transition: all 0.2s;
  flex-shrink: 0; /* Keeps button structured on wide viewports */
}

.phone-action-btn:hover {
  color: #b91c1c;
  background: #fff5f5; /* Fixed background toggle from teal back to your red theme */
  border-color: #fca5a5;
}

.phone-action-btn svg {
  flex-shrink: 0; /* Keeps icon from warping */
}

/* Responsive breakpoint configuration */
@media (max-width: 640px) {
  .exec-row-item {
    flex-direction: column;
    align-items: stretch; /* Forces elements to spread and fill width evenly */
    gap: 12px;
    padding: 16px;
  }

  .exec-meta {
    width: 100%;
  }

  .exec-role-desktop {
    display: none; /* Safely hides detailed descriptions on tiny viewports */
  }

  .phone-action-btn {
    width: 100%; /* Spreads button out flawlessly on mobile views */
    padding: 10px 14px;
    font-size: 14px;
  }
}
/* Base Styles */

.stat-and-contact {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-divider {
  position: relative;
  height: 2px;
  width: 100%;
  max-width: 900px;
  margin: 100px auto;

  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(185, 28, 28, 0.4) 20%,
    rgba(185, 28, 28, 0.8) 50%,
    rgba(185, 28, 28, 0.4) 80%,
    transparent 100%
  );
}
.about-us-section {
  padding: 100px 0;
  background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
  padding: 100px 0;
  border-top: 1px solid #f0f0f0;
  color: #1a1a1a;
  overflow: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Styling */
.section-intro {
  text-align: center;
  margin-bottom: 80px;
}

.sub-heading {
  display: block;
  font-weight: 700;
  color: #b91c1c;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 0.9rem;
  margin-bottom: 10px;
}

.main-heading {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 800;
  color: #111;
  margin-bottom: 20px;
}

.header-line {
  width: 60px;
  height: 4px;
  background: #b91c1c;
  margin: 0 auto;
}

/* Layout Grid */
.leader-profile {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  margin-bottom: 120px;
}

/* Image Wrapper Effects */
.image-wrapper {
  position: relative;
  z-index: 1;
}

.profile-img {
  width: 100%;
  aspect-ratio: 4/5;
  object-fit: cover;
  border-radius: 4px;
  filter: grayscale(20%);
  transition: all 0.5s ease;
  border: 1px solid #a9a5a5;
}

.image-wrapper::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 20px;
  right: -20px;
  bottom: -20px;
  border: 4px solid #ffffff;
  z-index: -1;
  border-radius: 4px;
}

.leader-profile:hover .profile-img {
  filter: grayscale(0%);
  transform: translateY(-5px);
}

/* Floating Badge */
.floating-badge {
  position: absolute;
  bottom: 30px;
  right: -10px;
  background: #b91c1c;
  color: white;
  padding: 15px 25px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.floating-badge .years {
  font-weight: 800;
  font-size: 1.2rem;
  letter-spacing: 1px;
  margin-bottom: 3px;
}

.floating-badge .focus {
  font-size: 0.75rem;
  text-transform: uppercase;
  opacity: 0.9;
}

/* Content Area */
.role-tag {
  color: #b91c1c;
  font-weight: 700;
  font-size: 0.8rem;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.name {
  font-size: 2.5rem;
  margin: 10px 0 5px;
  font-weight: 800;
}

.title {
  font-size: 1.1rem;
  color: #666;
  font-style: italic;
  margin-bottom: 30px;
}

.bio-text p {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #444;
  margin-bottom: 20px;
}

/* Stats Styling */
.stats-row {
  display: flex;
  gap: 50px;
  margin: 35px 0;
  border-left: 3px solid #f3f4f6;
  padding-left: 25px;
}

.stat-num {
  display: block;
  font-size: 1.8rem;
  font-weight: 800;
  color: #111;
}

.stat-desc {
  font-size: 0.8rem;
  color: #b91c1c;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
}

/* Contact Links */
.contact-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  margin-top: 30px;
}

.action-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #111;
  font-weight: 700;
  font-size: 1.25rem;
  transition: all 0.3s ease;
}

.action-link svg {
  color: #b91c1c;
}

.action-link:hover {
  color: #b91c1c;
  transform: translateX(5px);
}

/* Responsive Logic */
@media (max-width: 992px) {
  .leader-profile {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .coo-row .profile-info {
    order: 2;
  }

  .coo-row .profile-visual {
    order: 1;
  }

  .image-wrapper {
    max-width: 500px;
    margin: 0 auto;
  }

  .name {
    font-size: 2rem;
  }

  .stats-row {
    justify-content: space-around;
    border-left: none;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 20px 0;
  }
}
</style>
